export const ProductSelections = ({ data }) => {
  const variant = typeof data.variantName === "string" ? data.variantName.trim() : "";
  const items = Array.isArray(data.items) ? data.items : [];
  const ids = Array.isArray(data.itemIds) ? data.itemIds : [];
  const missingItems = ids.some(id => !items.some(item => item.itemId === id && typeof item.name === "string" && item.name.trim()));
  return <div className="productItem-selections">
    {variant && <div><strong>Opciones:</strong> {variant}</div>}
    {data.variantId && !variant && <div>Opciones históricas no disponibles</div>}
    {items.filter(item => typeof item.name === "string" && item.name.trim()).map((item, index) => <div key={`${item.itemId || "extra"}-${index}`}><strong>Atributo:</strong> {item.name}</div>)}
    {missingItems && <div>Hay extras históricos sin nombre disponible</div>}
    {typeof data.note === "string" && data.note.trim() && <div><strong>Nota:</strong> {data.note}</div>}
  </div>;
};
